import { render, staticRenderFns } from "./article-watch-item.vue?vue&type=template&id=1287b332&"
import script from "./article-watch-item.vue?vue&type=script&lang=js&"
export * from "./article-watch-item.vue?vue&type=script&lang=js&"
import style0 from "./article-watch-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports